const MS_PER_DAY = 24 * 60 * 60 * 1000;

export const DEMO_DISABLED_TITLE = 'Niedostępne w trybie demo';

export function computeDaysLeft(accessExpiresAt, now = new Date()) {
  if (!accessExpiresAt) return null;
  const expires = new Date(accessExpiresAt);
  if (Number.isNaN(expires.getTime())) return null;
  return Math.ceil((expires.getTime() - now.getTime()) / MS_PER_DAY);
}

export function formatDemoBannerText(daysLeft) {
  if (daysLeft === null || daysLeft === undefined) return null;
  if (daysLeft <= 0) return 'Demo wygasło';
  if (daysLeft === 1) return 'Tryb demo - wygasa za 1 dzień';
  return `Tryb demo - wygasa za ${daysLeft} dni`;
}
